import React, { Component, Fragment } from "react";

export default class SelectCampo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label>Campo: </label>
                            <select name="select" onChange={this.props.selectCampo} className="form-control" id={this.props.idComponente || "selectCampo"}>
                                <option value="0">N.° de Turmas</option>
                                <option value="1">Mat. Residuais</option>
                                <option value="2">Mat. Novas</option>
                                <option value="3">Total Mat.</option>
                                {/* <option value="4">Hora/aluno</option>
                                <option value="5">Hora/aluno Distribuida</option> */}
                                <option value="6">Hora/aluno Distribuida (% evasão)</option>
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}